import React from 'react'
import { TODO_STATUS } from '../../utils/constants/constant'
import './FilterTabs.scss'

const FilterTabs = ({ tabs, activeTab, onTabChange, counts }) => {
  const handleTabKeyDown = (event, tabKey) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onTabChange(tabKey)
    }
  }

  return (
    <div className="filter-tabs-container">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.key
        const showCount = counts[tab.key] !== undefined && tab.key !== TODO_STATUS.ALL_TASK.key
        return (
          <div
            key={tab.key}
            className={`filter-tab ${isActive ? 'active' : ''}`}
            role="button"
            tabIndex={0}
            aria-pressed={isActive}
            onClick={() => onTabChange(tab.key)}
            onKeyDown={(event) => handleTabKeyDown(event, tab.key)}
          >
            <span className="tab-label">{tab.label}</span>
            {showCount && (
              <span className={`tab-count ${tab.key.toLowerCase().replace(' ', '-')}`}>
                {counts[tab.key]}
              </span>
            )}
          </div>
        )
      }

      )}
    </div>
  )
}

export default FilterTabs
